import { fundacaoService } from '../services/fundacao.service.js'
const { getFiltroFundacao } = fundacaoService()
import SelectMultiple from '../components/SelectMultiple'

export default {
	components: { SelectMultiple },
	props: {
		modelValue: {
			type: Object,
			default: () => ({
				fundo: [],
				tag: [],
				tempoSenAtendimentoRapido: null,
			}),
		},
	},
	data() {
		return {
			fundoOption: [],
			tagOption: [],
			tempoSenAtendimentoRapidoOption: [
				{ label: '1 a 3 meses', value: '1,3' },
				{ label: '4 a 6 meses', value: '4,6' },
				{ label: 'Mais de 6 meses', value: '6,1000' },
			],
		}
	},
	emits: ['update:modelValue', 'aplicar-filtros', 'limpar-filtros'],
	methods: {
		async fetchOptions() {
			const listaFiltroFundacao = await getFiltroFundacao()
			this.fundoOption = listaFiltroFundacao?.fundos?.map((item) => ({
				value: item[1],
				label: item[1],
			}))
			this.tagOption = listaFiltroFundacao?.tags?.map((item) => ({
				value: item[0],
				label: item[1],
			}))
		},
		onChangeFundo(val) {
			this.$emit('update:modelValue', { ...this.modelValue, fundo: val })
		},
		onChangeTag(val) {
			this.$emit('update:modelValue', { ...this.modelValue, tag: val })
		},
		onChangeTempo(val) {
			this.$emit('update:modelValue', {
				...this.modelValue,
				tempoSenAtendimentoRapido: val,
			})
		},
		limparFiltros() {
			this.$emit('limpar-filtros')
		},
		aplicarFiltros() {
			this.$emit('aplicar-filtros')
		},
	},
	async mounted() {
		await this.fetchOptions()
	},
	template: `
        <section class="modal--content rounded-md w-full !overflow-visible relative" data-id="email_fundacao_filtros">
            <header class="flex items-center justify-between px-24 pt-24 pb-16 bg-primary-pure">
                <h2 class="text-lg font-medium text-white">Filtros</h2>
            </header>
            <div class="flex flex-col gap-24 !p-24 w-full">
                <div class="flex flex-col gap-4 w-full">
                    <label class="text-sm text-neutral-80 font-medium"> Fundos: </label>
                    <select-multiple
                        :options="fundoOption"
                        :model="modelValue.fundo"
                        :submitfc="() => {}"
                        @changed="onChangeFundo">
                    </select-multiple>
                </div>
                <div class="flex flex-col gap-4 w-full">
                    <label class="text-sm text-neutral-80 font-medium"> Tags: </label>
                    <select-multiple
                        :options="tagOption"
                        :model="modelValue.tag"
                        :submitfc="() => {}"
                        @changed="onChangeTag">
                    </select-multiple>
                </div>
                <div class="flex flex-col gap-4 w-full">
                    <label class="text-sm text-neutral-80 font-medium"> Faixas: </label>
                    <q-select
                        class="q-select-tempo-filtro"
                        :options="tempoSenAtendimentoRapidoOption"
                        :model-value="modelValue.tempoSenAtendimentoRapido"
                        @update:model-value="onChangeTempo"
                        option-value="value"
                        option-label="label"
                        emit-value
                        map-options
                        clearable
                        outlined
                        placeholder="Selecione uma faixa de tempo..."
                        behavior="menu"
                        :menu-props="{ maxHeight: '200px' }">
                    </q-select>
                </div>
            </div>
            <div class="w-full flex gap-24 justify-between items-center p-24 !mt-96">
                <button type="button" class="btn h-48 secondary" @click="limparFiltros">
                    Limpar Filtros
                </button>
                <button type="button" class="btn h-48 primary" @click="aplicarFiltros">
                    Aplicar Filtros
                </button>
            </div>
        </section>
    `,
}
